





import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import AdminHeader from "@/components/admin/Header.vue";
import UserHeader from "@/components/user/Header.vue";

@Component({
  components: {
    AdminHeader,
    UserHeader
  }
})
export default class extends Vue {
  @Getter("auth/isAdmin")
  public isAdmin!: boolean;

  // @Watch("isAdmin")
  // setViewport() {
  //   this.changeViewPort();
  // }

  created() {
    this.changeViewPort();
  }

  public changeViewPort() {
    const viewport = document.querySelector("meta[name='viewport']");
    if (!viewport) {
      return;
    }
    viewport.setAttribute("content", "width=device-width,initial-scale=1.0");

    // if (!this.isAdmin) {
    //   viewport.setAttribute("content", "width=device-width,initial-scale=1.0");
    // } else {
    //   viewport.setAttribute("content", "");
    // }
  }
}
